jQuery('.gform_wrapper select[multiple=multiple]').each(function() {
    jQuery(this).attr('size', jQuery(this).find('option').length);
});